export default class DirectiveHtmlClass {
  static install(Vue, options) {
    Vue.directive("htmlclass", {
      created() {
        if (document && document.documentElement.classList == undefined) {
          config.DEBUG && console.warn("htmlclass: DOM.classList is not available, use polyfill")
        }
      },
      update(el, binding) {
        let val = binding.value
        for (let i in val) {
          let act = val[i]
          if (act == true) {
            document.documentElement.classList.add(i)
          } else {
            document.documentElement.classList.remove(i)
          }
        }
      },
      inserted(el, binding) {
        binding.def.update(el, binding)
      },
      unbind(el, binding) {
        let val = binding.value
        for (let i in val) {
          document.documentElement.classList.remove(i)
        }
      }
    })
  }
}
